import { useState } from 'react'
import { Button, Select, cn } from '@pcln/horizon'
import useBootstrapData from '@/hooks/useBootstrapData'
import { createDateOptions, currentMonth } from '../SearchForm/utils'
import {
  locationOptions,
  cruiseLineOptions,
  durationOptions
} from '../constants'
import { useCruiseFormSubmit } from './useCruiseFormSubmit'

const createOption = (option: {
  label: string
  value: string
  disabled?: boolean
  selected?: boolean
}) => ({
  label: option.label,
  value: option.value,
  disabled: option.disabled || false
})

const locations = locationOptions.map(createOption)
const cruiseLines = cruiseLineOptions.map(createOption)
const dateOptions = createDateOptions(new Date()).map(createOption)
const durations = durationOptions.map(createOption)

function HorizonCruiseForm() {
  const [location, setLocation] = useState('')
  const [cruiseLine, setCruiseLine] = useState('')
  const [startDate, setStartDate] = useState(currentMonth)
  const [duration, setDuration] = useState('')

  const {
    isMobile,
    referral,
    webstats: { clientGUID: cguid }
  } = useBootstrapData()

  const formData = {
    location,
    cruiseLine,
    startDate,
    duration
  }

  const { onSubmit } = useCruiseFormSubmit({
    formData,
    referral,
    cguid,
    isMobile
  })

  return (
    <div className="w-full">
      <form onSubmit={onSubmit} aria-label="cruise search">
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_minmax(0,1fr)_max-content] mx-auto">
          <Select
            label="Destination"
            isInset
            iconLeft="search"
            menuItems={locations}
            value={location}
            onChange={setLocation}
            placeholder="Destination"
            initialValue="Destination"
          />

          <Select
            label="Departure date"
            iconLeft="calendar_month"
            isInset
            menuItems={dateOptions}
            value={startDate}
            onChange={setStartDate}
            placeholder="Select date"
          />

          <Select
            iconLeft="calendar_clock"
            label="Cruise Length"
            isInset
            menuItems={durations}
            value={duration}
            onChange={setDuration}
            placeholder="Any length"
          />

          <Select
            iconLeft="directions_boat"
            label="Cruise Line"
            isInset
            menuItems={cruiseLines}
            value={cruiseLine}
            onChange={setCruiseLine}
            placeholder="All cruise lines"
          />

          <Button
            buttonType="submit"
            type="primary"
            size="lg"
            className={cn(
              isMobile
                ? 'fixed bottom-4 right-4 left-4 sm:col-span-2'
                : 'w-full sm:col-span-2 lg:col-span-1'
            )}
          >
            Search
          </Button>
        </div>
      </form>
    </div>
  )
}

export default HorizonCruiseForm
